var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderFileConfigurations(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.758,
    height: 27.28,
    viewBox: "0 0 64.758 27.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23642",
    "data-name": "Group 23642",
    transform: "translate(-249.577 -207.972)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-file-text",
    "data-name": "Icon feather-file-text",
    transform: "translate(250.577 208.972)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43066",
    "data-name": "Path 43066",
    d: "M18.64,3H8.528A2.528,2.528,0,0,0,6,5.528V25.752A2.528,2.528,0,0,0,8.528,28.28H23.7a2.528,2.528,0,0,0,2.528-2.528V10.584Z",
    transform: "translate(-6 -3)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43067",
    "data-name": "Path 43067",
    d: "M21,3v7.584h7.584",
    transform: "translate(-8.36 -3)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43068",
    "data-name": "Path 43068",
    d: "M22.112,19.5H12",
    transform: "translate(-6.944 -5.596)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43069",
    "data-name": "Path 43069",
    d: "M22.112,25.5H12",
    transform: "translate(-6.944 -6.54)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43070",
    "data-name": "Path 43070",
    d: "M14.528,13.5H12",
    transform: "translate(-6.944 -4.652)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-file-text-2",
    "data-name": "Icon feather-file-text",
    transform: "translate(293.112 208.972)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43066-2",
    "data-name": "Path 43066",
    d: "M18.64,3H8.528A2.528,2.528,0,0,0,6,5.528V25.752A2.528,2.528,0,0,0,8.528,28.28H23.7a2.528,2.528,0,0,0,2.528-2.528V10.584Z",
    transform: "translate(-6 -3)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43067-2",
    "data-name": "Path 43067",
    d: "M21,3v7.584h7.584",
    transform: "translate(-8.36 -3)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43068-2",
    "data-name": "Path 43068",
    d: "M22.112,19.5H12",
    transform: "translate(-6.944 -5.596)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43069-2",
    "data-name": "Path 43069",
    d: "M22.112,25.5H12",
    transform: "translate(-6.944 -6.54)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43070-2",
    "data-name": "Path 43070",
    d: "M14.528,13.5H12",
    transform: "translate(-6.944 -4.652)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-arrow-right",
    "data-name": "Icon feather-arrow-right",
    transform: "translate(278.202 217.857)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43071",
    "data-name": "Path 43071",
    d: "M7.5,18h7.51",
    transform: "translate(-7.5 -14.245)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43072",
    "data-name": "Path 43072",
    d: "M18,7.5l3.755,3.755L18,15.01",
    transform: "translate(-14.245 -7.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderFileConfigurations);
export default __webpack_public_path__ + "static/media/OrderFileConfigurations.27e67973703b6ad146bc3c54c6323245.svg";
export { ForwardRef as ReactComponent };